import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatErr } from "../context/AuthContext";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card } from "../components/ui/card";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [oldp, setOldp] = useState("");
  const [newp, setNewp] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (newp !== confirm) { setErr("Le password non coincidono"); return; }
    if (newp.length < 6) { setErr("Minimo 6 caratteri"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/auth/change-password", { old_password: oldp, new_password: newp });
      await refresh();
      toast.success("Password aggiornata");
      if (user?.role === "admin" || user?.role === "personale") navigate("/admin", { replace: true });
      else navigate("/dashboard", { replace: true });
    } catch (e) {
      setErr(formatErr(e));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar/>
      <div className="max-w-md mx-auto pt-12 px-4">
        <Card className="p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-md bg-amber-500 flex items-center justify-center"><KeyRound className="w-5 h-5 text-white"/></div>
            <div>
              <h1 className="heading text-2xl font-extrabold text-slate-900">Cambia password</h1>
              {user?.must_change_password && <p className="text-sm text-amber-700">Al primo accesso è obbligatorio cambiare la password</p>}
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="change-password-form" autoComplete="off">
            <input type="text" name="username" autoComplete="username" hidden readOnly value={user?.email || ""}/>
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-slate-600 mb-1 block">Password attuale</label>
              <Input type="password" required value={oldp} onChange={e=>setOldp(e.target.value)} autoComplete="current-password" data-testid="change-oldp"/>
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-slate-600 mb-1 block">Nuova password</label>
              <Input type="password" required minLength={6} value={newp} onChange={e=>setNewp(e.target.value)} autoComplete="new-password" data-testid="change-newp"/>
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-slate-600 mb-1 block">Conferma password</label>
              <Input type="password" required minLength={6} value={confirm} onChange={e=>setConfirm(e.target.value)} autoComplete="new-password" data-testid="change-confirm"/>
            </div>
            {err && <div className="text-sm text-red-600 bg-red-50 rounded p-2" data-testid="change-error">{err}</div>}
            <Button type="submit" disabled={busy} className="w-full bg-blue-800 hover:bg-blue-900" data-testid="change-submit">
              {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : "Aggiorna password"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
